export default {
    path: '/logout',
    name: 'Logout',
    meta: {
        title: 'Logout',
        documentTitle: 'Logout',
        requiresAuth: true,
        loggedIn: false,
    },
    component: () => import( /* webpackChunkName: "Logout" */ '@/views/Logout' ),
};
